<ngb-toast
  *ngFor="let toast of toastService.toasts()"
  [class]="toast.classname"
  [header]="toast.closeButton || !toast.autohide ? ' ' : undefined"
  [autohide]="toast.autohide"
  [delay]="toast.delay || 5000"
  (hidden)="toastService.remove(toast)"
  (click)="toast.closeOnClick !== false && toastService.remove(toast)"
>
  <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="$any(toast.textOrTpl)"></ng-template>
  </ng-template>

  <ng-template #text>{{ toast.textOrTpl }}</ng-template>
</ngb-toast>
